import { match } from 'ts-pattern'

export enum ProfileEligibilityRequirements {
  Available = 'AVAILABLE',
  RequireUtility = 'REQUIRE_UTILITY_PROVIDER',
  RequireLocation = 'REQUIRE_LOCATION',
  RequireSurvey = 'REQUIRE_SURVEYS_COMPLETED',
  Device = 'DEVICE',
  AvaVerified = 'AVA_VERIFIED',
  RequirePlan = 'REQUIRE_UTILITY_PLAN',
  ExternalUtilityConnectionAttempt = 'EXTERNAL_UTILITY_CONNECTION_ATTEMPT',
  RequireUtilityAccountNumber = 'REQUIRE_UTILITY_ACCOUNT_NUMBER',
}

export function profileIneligibilityReasonContent(
  key: ProfileEligibilityRequirements,
) {
  return match(key)
    .returnType<string>()
    .with(
      ProfileEligibilityRequirements.Available,
      () => 'This program is currently full or unavailable.',
    )
    .with(
      ProfileEligibilityRequirements.RequireLocation,
      () => 'Your location is not eligible for this program.',
    )
    .with(
      ProfileEligibilityRequirements.Device,
      () => 'You must have an eligible device to enroll in this program.',
    )
    .with(
      ProfileEligibilityRequirements.AvaVerified,
      () =>
        'You must complete verification with Ava to enroll in this program.',
    )
    .with(
      ProfileEligibilityRequirements.RequireSurvey,
      () => 'You must complete the required surveys to enroll in this program.',
    )
    .with(
      ProfileEligibilityRequirements.RequirePlan,
      () => 'You must select your utility plan to enroll in this program.',
    )
    .with(
      ProfileEligibilityRequirements.ExternalUtilityConnectionAttempt,
      () =>
        'You must connect to an external utility to enroll in this program.',
    )
    .with(
      ProfileEligibilityRequirements.RequireUtilityAccountNumber,
      () =>
        'You must provide your utility account number to enroll in this program.',
    )
    .otherwise(
      () =>
        `This profile requirement (${key.toString()}) is missing ineligibility content.`,
    )
}
